export enum BUTTON_CONTAINER_ALIGNMENT {
	Horizontal = 'horizontal',
	Vertical = 'vertical'
}
